import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { STEPS } from "./content";

const Step = ({ s, i }) => (
  <motion.div data-testid={`step-${s.n}`}
    initial={{ opacity: 0.001, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ x: 8 }}
    className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 py-8 sm:py-10 border-t border-cream/15">
    <span className="font-display text-5xl sm:text-7xl text-butter/90 leading-none">{s.n}</span>
    <div>
      <h3 className="font-display text-2xl sm:text-3xl text-cream">{s.title}</h3>
      <p className="mt-3 text-[#D9E3DB] text-base leading-relaxed max-w-lg">{s.text}</p>
    </div>
  </motion.div>
);

export const HowItWorks = () => (
  <section id="como-funciona" data-testid="how-section" className="relative bg-ink py-24 md:py-36 overflow-hidden">
    <div className="absolute -right-40 top-20 w-[480px] h-[480px] rounded-full bg-sage/40 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal><Eyebrow light>Terapia on-line</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl text-cream leading-[1.05] tracking-tight">
              Como funciona, <span className="italic text-blush">passo a passo.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 relative aspect-[4/3] rounded-[2rem] overflow-hidden">
              <img src="/img/bright.jpg" alt="Notebook e café prontos para a sessão on-line" className="w-full h-full object-cover object-[50%_35%] transition-transform duration-[1.6s] hover:scale-105" />
            </div>
          </Reveal>
        </div>
      </div>
      <div className="lg:col-span-7 lg:pt-20">
        {STEPS.map((s, i) => <Step key={s.n} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
